module.exports = __webpack_public_path__ + "assets/img_growbehold.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_growbehold.jpg
 ** module id = 125
 ** module chunks = 1
 **/